/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { FieldHeading } from '@api';
import { isNil } from 'lodash';
import * as React from 'react';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Form, reduxForm } from 'redux-form';
import { toFormKey } from 'src/js/components/form/FieldFactory';
import { syncFieldValues } from 'src/js/enrol/containers/summary/actions/Actions';
import { AdobeAnalyticsFormAbandonTrackService } from 'src/js/services/AdobeAnalyticsService';
import { IshState } from 'src/js/services/IshState';
import HeadingComp from '../../../components/HeadingComp';

const CustomFields = (
  {
   form, dispatch, forms, submitFailed, headings, selected, onUpdate, handleSubmit
}) => {
 useEffect(() => {
   AdobeAnalyticsFormAbandonTrackService.attachFormAbandonClicksTrack(form, dispatch)
   return () => {
     AdobeAnalyticsFormAbandonTrackService.detachFormAbandonClicksTrack()
   }
 }, [])

  const getFormErrors = () => {
    if (forms && forms[form]) {
      const formErrors = forms[form].syncErrors;

      if (formErrors && submitFailed) {
        const errors = Object.values<any>(formErrors);

        return errors.length > 0 && (
          <div className="validation">
            <ul>
              {errors.map((er, i) => (
                <li key={i}>
                  {er}
                </li>
              ))}
            </ul>
          </div>
        );
      }
    }

    return null;
  }

  const headingsComp = isNil(headings) ? [] : headings.map((h, index) => (
    <HeadingComp allHeadings={headings} heading={h} key={index} touch={() => onUpdate(form)} form={form} dispatch={dispatch} />
  ));

  return (
    <div className="course-fields col-sm-24">
      {headings && selected
        && (
          <Form
            onSubmit={handleSubmit}
            onBlur={() => onUpdate(form)}
          >
            {getFormErrors()}
            {headingsComp}
          </Form>
        )}
    </div>
  );
}

const CustomFieldsForm = reduxForm<any,{ selected: boolean, headings: FieldHeading[] }>({
  destroyOnUnmount: false,
  shouldError: () => true,
  validate: (data, props) => {
    const errors = {};

    if (!props.selected) return errors;

    if (props.registeredFields && props.headings && props.headings.length) {
      props.headings.map((headings) => headings.fields.map((field, index) => {
        const fieldKey = toFormKey(field.key, index);

        return ((field.mandatory
          && !data[fieldKey]
          && props.registeredFields[fieldKey])
          ? errors[toFormKey(field.key, index)] = `Field '${field.name}' is required`
          : field)
      }));
    }

    return errors;
  },
  onChange: (values, dispatch) => {
    dispatch(syncFieldValues())
  }
})(CustomFields as any);

export default connect<any, any, any, IshState>((state: any) => ({ forms: state.form }))(CustomFieldsForm) as any;